<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'Szkoleniowcy'"></app-breadcrumb>
<div class="idd-training-trainer-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field class="idd-training-trainer-list-filter">
      <mat-label>Imie</mat-label>
      <input matInput placeholder="Imię" name="contains$firstName" [(ngModel)]="initialFilters.contains$firstName">
    </mat-form-field>

    <mat-form-field class="idd-training-trainer-list-filter">
      <mat-label>Nazwisko</mat-label>
      <input  matInput placeholder="Nazwisko" name="contains$lastName" [(ngModel)]="initialFilters.contains$lastName">
    </mat-form-field>

    <app-datepicker
      class="idd-training-trainer-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="idd-training-trainer-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field class="idd-training-trainer-list-filter">
      <mat-label>Aktywny</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).idd_training.write" mat-stroked-button color="primary" class="add-button" (click)="addContractWithEmployee()"><mat-icon>add</mat-icon> Dodaj Szkoleniowca</button>

    <span fxFlex></span>
    <div>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    </div>
    <div>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="iddTrainingTrainer" >

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Imię i nazwisko </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/szkolenie/szkoleniowcy/szczegoly', element.uuid]">{{element.firstName}} {{element.lastName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Notatka </th>
      <td mat-cell *matCellDef="let element">
        {{element.memo}}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Aktywny </th>
      <td mat-cell *matCellDef="let element">
        {{!element.active? 'NIE' : 'TAK'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
